import request from '@/axios'
import type { LoginForm, UserType, CaptchaForm } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: LoginForm): Promise<IResponse<UserType>> => {
  return request.post({
    url: '/api/login',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/api/logout' })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/role/list', params })
}

export const getUserRoutersApi = (): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/api/user/routers' })
}

export const getUserRolesApi = (username) => {
  return request.get({ url: `api/login/${username}/roles` })
}

export const getLoginInfoApi = (phoneNumber: string) => {
  return request.post({ url: `/api/login/info/${phoneNumber}` })
}

// captcha version

// 获取商家列表
export const fetchBusinessByPhoneNumberApi = (phoneNumber: string) => {
  return request.get({ url: `/api/login/${phoneNumber}/businesses` })
}
// 获取角色列表
export const fetchRoleByPhoneNumberAndBusinessIdApi = (phoneNumber: string, businessId: number) => {
  return request.get({ url: `/api/login/${phoneNumber}/businesses/${businessId}/roles` })
}
// 发送短信验证码
export const sendCaptchaApi = (phoneNumber: string) => {
  return request.post({ url: `/api/login/sms/${phoneNumber}` })
}
// 验证码登录
export const captchaLoginApi = (data: CaptchaForm) => {
  return request.post({
    url: '/api/captcha-login',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 切换登录用户
export const switchLoginUserApi = (params) => {
  return request.post({ url: '/api/login/switch', params })
}

// 提交验证码
export const submitCaptchaApi = (phoneNumber: string, captcha: string) => {
  return request.post({ url: `/api/login/${phoneNumber}/captcha/${captcha}` })
}
